<template>
  <section id="videos" class="videos">
    <div class="container">
      <div class="section-header">
        <h2>Videos</h2>
        <div class="celtic-divider">
          <span></span>
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M12,2C9.1,2,6.8,4.3,6.8,7.2c0,1.7,0.8,3.3,2.1,4.3c-1.3,1-2.1,2.5-2.1,4.3c0,1.7,0.8,3.3,2.1,4.3C7.6,21,6.8,22.5,6.8,24h2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4h2.4c0-1.5-0.8-3-2.1-3.9c1.3-1,2.1-2.5,2.1-4.3c0-1.7-0.8-3.3-2.1-4.3c1.3-1,2.1-2.5,2.1-4.3C16.8,4.3,14.9,2,12,2z" />
          </svg>
          <span></span>
        </div>
      </div>
      
      <div v-if="videos.length === 0" class="empty-state">
        <p>Keine Videos verfügbar.</p>
      </div>
      
      <div v-else class="video-grid">
        <div v-for="video in videos" :key="video.id" class="video-item">
          <div class="video-preview">
            <iframe 
              :src="getEmbedUrl(video.youtube_url)" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen
            ></iframe>
          </div>
          <div class="video-info">
            <h3>{{ video.title }}</h3>
            <p>{{ video.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VideoGallery',
  data() {
    return {
      videos: []
    }
  },
  methods: {
    async loadVideos() {
      try {
        const response = await fetch('/api/videos_simple.php', {
          credentials: 'include'
        })
        const data = await response.json()
        if (data.success) {
          this.videos = data.videos
        } else {
          console.error('Fehler beim Laden der Videos:', data.error)
        }
      } catch (error) {
        console.error('Fehler beim Laden der Videos:', error)
      }
    },
    
    getEmbedUrl(youtubeUrl) {
      const videoId = this.extractVideoId(youtubeUrl)
      return `https://www.youtube.com/embed/${videoId}`
    },
    
    extractVideoId(url) {
      const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
      const match = url.match(regex)
      return match ? match[1] : null
    }
  },
  mounted() {
    this.loadVideos()
  }
}
</script>

<style scoped>
.videos {
  padding: 60px 0;
  background-color: var(--bg-color);
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-header h2 {
  font-size: 2.5rem;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-family: var(--font-family-serif);
  font-weight: 600;
}

.celtic-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  margin: 1rem auto;
}

.celtic-divider span {
  height: 1px;
  width: 100px;
  background-color: var(--primary-color);
  opacity: 0.5;
}

.celtic-divider svg {
  margin: 0 1rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
}

.video-item {
  background-color: var(--white);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.video-item:hover {
  transform: translateY(-5px);
}

.video-preview {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
}

.video-preview iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-info {
  padding: 20px;
}

.video-info h3 {
  margin: 0 0 10px 0;
  color: var(--text-color);
  font-size: 1.2rem;
}

.video-info p {
  margin: 0;
  color: var(--text-muted);
  line-height: 1.6;
}

.empty-state {
  text-align: center;
  padding: 40px;
  background-color: var(--white);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Responsive */
@media (max-width: 768px) {
  .video-grid {
    grid-template-columns: 1fr;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
  
  .celtic-divider span {
    width: 60px;
  }
}
</style> 